import React from "react";
import styled from "styled-components";


import dotnet from './dotnet-icon.png';
import godot from './godot-icon.png';
import reaper from './reaper-icon.png';
import typescript from './typescript.png';
import react from './react.png';
import kafka from './kafka.png';
import terraform from './terraform.png';
import nodejs from './nodejs.png';
import sumologic from './sumologic.svg';
import newRelic from './newrelic.png';
import datadog from './datadog.avif';
import aws from './aws.png';
import k8s from './k8s.png';
import docker from './docker.png';
import lua from './lua.png';
import python from './python.jpg';
import cpp from './cpp.png'
import unity from './unity.png'
import bash from './bash.png'

export const ActivityTopicsContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;

  @media (max-width: 400px) {
    flex-direction: column;
  }
`;

export const ActivityTopic = styled.div`
  ${(props) => `
border-radius: 20px;
box-sizing: border-box;
padding: 10px;
text-align: center;

transition: all ease 0.2s;

& img {
    height: 90px;
    border-radius: 20px;
    box-shadow:
    0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 22.3px 17.9px rgba(0, 0, 0, 0.072),
    0 41.8px 33.4px rgba(0, 0, 0, 0.086),
    0 100px 80px rgba(0, 0, 0, 0.12)
}

:hover, :active {
   transform: scale(1.1);
}

@media (max-width: 500px) {
    width: 100%;
  }

`};
`;

export type TopicName = "dotnet" 
| "godot"
|"reaper"
|"typescript"
|"react"
|"python" 
| "kafka"
| "nodejs"
| "sumologic"
| "newrelic"
| "datadog"
| "aws"
  | "k8s"
  | "docker"
  | "lua"
  | "python"
   | "cpp"
 | "unity"
 | "bash"
| "terraform";

export const DotnetTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={dotnet} alt="Dotnet C# logo" />
    </ActivityTopic>

export const TypescriptTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={typescript} alt="Typescript logo" />
    </ActivityTopic>

export const PythonTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={python} alt="python logo" />
    </ActivityTopic>

export const UnityTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={unity} alt="Unity logo" />
    </ActivityTopic>

export const ReactTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={react} alt="React logo" />
    </ActivityTopic>

export const KafkaTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={kafka} alt="Kafka logo" />
    </ActivityTopic>

export const TerraformTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={terraform} alt="Terraform logo" />
    </ActivityTopic>

export const NodeJsTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={nodejs} alt="NodeJs logo" />
    </ActivityTopic>

export const SumologiTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={sumologic} alt="Sumologi logo" />
    </ActivityTopic>

export const NewRelicTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={newRelic} alt="NewRelic logo" />
    </ActivityTopic>

export const DatadogTechTopic : React.FC<{}> = () => 
    <ActivityTopic>
    <img src={datadog} alt="Datadog logo" />
    </ActivityTopic>

export const GodotTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={godot} alt="Godot Game Engine Robot Logo" />
        </ActivityTopic>

export const AwsTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={aws} alt="Aws Logo" />
        </ActivityTopic>

export const K8sTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={k8s} alt="k8s Logo" />
        </ActivityTopic>

export const DockerTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={docker} alt="docker Logo" />
        </ActivityTopic>

export const LuaTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={lua} alt="lua Logo" />
        </ActivityTopic>

export const BashTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={bash} alt="bash Logo" />
        </ActivityTopic>

export const CppTechTopic : React.FC<{}> = () => 
        <ActivityTopic>
    <img src={cpp} alt="cpp Logo" />
        </ActivityTopic>

export const ReaperTechTopic: React.FC<{}> = () =>
        <ActivityTopic>

    <img src={reaper} alt="Reaper Music DAW software logo" />
        </ActivityTopic>

interface Dictionary<T> {
    [Key: string] : T;
}
export const TechTopicsToComponentsMap: Dictionary<React.FC> = {
    "dotnet": DotnetTechTopic,
    "godot": GodotTechTopic,
    "reaper": ReaperTechTopic
}

export const TechTopicNameToComponent = (name: TopicName) => {
    if (name === "dotnet") {
        return <DotnetTechTopic/>
    }
        if (name === "typescript") {
        return <TypescriptTechTopic/>
    }
        if (name === "react") {
        return <ReactTechTopic/>
    }
        if (name === "bash") {
        return <BashTechTopic/>
    }

    if (name === "godot") {
        return <GodotTechTopic/>
    }
        if (name === "reaper") {
        return <ReaperTechTopic/>
    }
        if (name === "kafka") {
        return <KafkaTechTopic/>
    }
        if (name === "terraform") {
        return <TerraformTechTopic/>
    }
        if (name === "nodejs") {
        return <NodeJsTechTopic/>
    }
        if (name === "sumologic") {
        return <SumologiTechTopic/>
    }
        if (name === "newrelic") {
        return <NewRelicTechTopic/>
    }
        if (name === "datadog") {
        return <DatadogTechTopic/>
    }
        if (name === "aws") {
        return <AwsTechTopic/>
    }
    if (name === "k8s") {
        return <K8sTechTopic/>
    }
    if (name === "docker") {
        return <DockerTechTopic/>
    }
    if (name === "lua") {
        return <LuaTechTopic/>
    }
    if (name === "python") {
        return <PythonTechTopic/>
    }
    if (name === "cpp") {
        return <CppTechTopic/>
    }
    if (name === "unity") {
        return <UnityTechTopic/>
    }
}